// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/**
 * Color definitions for the app
 */

.SidePanel {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 1301;
  pointer-events: none;
  transition: 0.8s ease backdrop-filter, 0.8s ease background-color;
}
.SidePanel.show.backdrop {
  pointer-events: auto;
  background-color: rgba(34, 39, 50, 0.5);
  backdrop-filter: blur(2px);
}
.SidePanel > .backdrop-container {
  display: flex;
  height: 100%;
}
.SidePanel > .backdrop-container .backdrop-left {
  flex-grow: 1;
}
.SidePanel .panel-root {
  position: absolute;
  top: 0;
  right: 0;
  height: 100%;
  pointer-events: none;
  overflow: hidden !important;
}
.SidePanel .panel-container {
  display: inline-flex;
  position: relative;
  height: 100%;
  transition: 0.8s ease right, 0.8s ease width;
}
.SidePanel .panel-container > .panel {
  display: flex;
  flex-direction: column;
  position: relative;
  height: 100%;
  background: #FFFFFF;
  box-shadow: 0 0 16px 0 rgba(0, 0, 0, 0.32);
  box-sizing: border-box;
  border-left: 1px solid #E1E1E9;
  pointer-events: auto;
  overflow: hidden;
}
.SidePanel .panel-container > .panel.panel-secondary, .SidePanel .panel-container > .panel.panel-tertiary, .SidePanel .panel-container > .panel.panel-fourth {
  box-shadow: none;
}
.SidePanel .panel-container > .panel.transition {
  transition: none;
}
.SidePanel .panel-container > .panel > .header {
  display: flex;
  flex-direction: column;
  justify-content: center;
  height: 72px;
  padding: 0 24px;
  padding-right: 0;
  box-sizing: border-box;
  border-bottom: 1px solid #E1E1E9;
}
.SidePanel .panel-container > .panel > .header .toolbar {
  display: flex;
  align-items: center;
}
.SidePanel .panel-container > .panel > .header .toolbar .title {
  flex-grow: 1;
  font-size: 18px;
  line-height: 20px;
  font-weight: 900;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.SidePanel .panel-container > .panel > .header .toolbar .VibeIcon {
  padding: 24px 4px;
}
.SidePanel .panel-container > .panel > .header .toolbar .VibeIcon:first-child {
  padding-left: 24px;
}
.SidePanel .panel-container > .panel > .header .toolbar .VibeIcon:last-child {
  padding-right: 24px;
}
.SidePanel .panel-container > .panel > .header .toolbar .VibeIcon.left-icon {
  padding: 0;
  margin-right: 4px;
}
.SidePanel .panel-container > .panel > .content {
  position: relative;
  flex-grow: 1;
  overflow: hidden;
}`, "",{"version":3,"sources":["webpack://./src/vibeguide/src/sass/color.scss","webpack://./src/vibeguide/src/components/SidePanel/SidePanel.scss"],"names":[],"mappings":"AAAA;;EAAA;;ACEA;EACE,eAAA;EACA,MAAA;EACA,OAAA;EACA,WAAA;EACA,YAAA;EACA,aAAA;EACA,oBAAA;EACA,iEAAA;AAwFF;AApFI;EAEE,oBAAA;EACA,uCDqCQ;ECpCR,0BAAA;AAqFN;AAjFE;EACE,aAAA;EACA,YAAA;AAmFJ;AAjFI;EACE,YAAA;AAmFN;AA/EE;EACE,kBAAA;EACA,MAAA;EACA,QAAA;EACA,YAAA;EACA,oBAAA;EACA,2BAAA;AAiFJ;AA9EE;EACE,oBAAA;EACA,kBAAA;EACA,YAAA;EACA,4CAAA;AAgFJ;AA9EI;EACE,aAAA;EACA,sBAAA;EACA,kBAAA;EACA,YAAA;EACA,mBD7BE;EC8BF,0CAAA;EACA,sBAAA;EACA,8BAAA;EACA,oBAAA;EACA,gBAAA;AAgFN;AA9EM;EAGE,gBAAA;AA8ER;AA3EM;EACE,gBAAA;AA6ER;AA1EM;EACE,aAAA;EACA,sBAAA;EACA,uBAAA;EACA,YAAA;EACA,eAAA;EACA,gBAAA;EACA,sBAAA;EACA,gCAAA;AA4ER;AA1EQ;EACE,aAAA;EACA,mBAAA;AA4EV;AA1EU;EACE,YAAA;EACA,eAAA;EACA,iBAAA;EACA,gBAAA;EACA,mBAAA;EACA,gBAAA;EACA,uBAAA;AA4EZ;AAxEU;EACE,iBAAA;AA0EZ;AAxEY;EACE,kBAAA;AA0Ed;AAvEY;EACE,mBAAA;AAyEd;AArEY;EACE,UAAA;EACA,iBAAA;AAuEd;AAjEM;EACE,kBAAA;EACA,YAAA;EACA,gBAAA;AAmER","sourcesContent":["/**\n * Color definitions for the app\n */\n\n// Theme Colors\n$primary: #333F48;\n$secondary: #222732;\n$yellow: #FECF0C;\n$red: #E02D4F;\n$teal: #23CCC3;\n$orange: #F66733;\n$lightGray: #F6F6F6;\n$whiteSmoke: #E1E1E9;\n$manatee: #959AAD;\n$obsidian: #383838;\n\n// Status Colors\n$success: #00A474;\n$warning: #FFC107;\n$error: #CF0838;\n\n// Other Colors\n$white: #FFFFFF;\n$black: #000000;\n$gray: #757575;\n$darkGray: #A4A7B7;\n$mediumGray: #E0E0E0;\n$lighterGray: #E3E7F4;\n$lightSlateGray: #8A8FA3;\n$carrot: #FF892E;\n$lightSmoke: #F5F4F5;\n$graphBlue: #1570EF;\n$lightOrchid: #7F56D9;\n$rainboots: #3361E1;\n$royalBlue: #4085DE;\n$sushi: #95C653;\n\n// Component Colors\n$primaryButtonBackground: $yellow;\n$primaryButtonText: $primary;\n$secondaryButtonBackground: $primary;\n$secondaryButtonText: $white;\n$navigationText: #95A3AD;\n$scheduleMusic: #FCC7B3;\n$scheduleMessageBlock: $teal;\n$scheduleInterrupt: #1997A3;\n$scheduleLoop: $primary;\n\n// Variants: Theme Colors\n$primary16: rgba($primary, 0.16);\n$primary40: rgba($primary, 0.4);\n$primary50: rgba($primary, 0.5);\n$primary60: rgba($primary, 0.6);\n$secondary25: rgba($secondary, 0.25);\n$secondary50: rgba($secondary, 0.5);\n$secondary75: rgba($secondary, 0.75);\n$yellow16: rgba($yellow, 16%);\n$yellow25: rgba($yellow, 25%);\n$yellow75: rgba($yellow, 75%);\n$orange16: rgba($orange, 0.16);\n$orange32: rgba($orange, 0.32);\n$orange50: rgba($orange, 0.5);\n$orange75: rgba($orange, 0.75);\n$manatee16: rgba($manatee, 0.16);\n$manatee50: rgba($manatee, 0.5);\n\n// Variants: Status Colors\n$success10: rgba($success, 0.08);\n$success16: rgba($success, 0.16);\n$success75: rgba($success, 0.75);\n$warning50: rgba($warning, 0.5);\n$error10: rgba($error, 0.1);\n$error16: rgba($error, 0.16);\n$error20: rgba($error, 0.2);\n$error50: rgba($error, 0.5);\n$error75: rgba($error, 0.75);\n$error85: rgba($error, 0.85);\n\n// Variants: Other Colors\n$gray50: #F9FAFB;\n$gray200: #EAECF0;\n$gray300: #D0D5DD;\n$gray400: #98A2B3;\n$gray500: #667085;\n$gray700: #344054;\n$gray900: #101828;\n$carrot16: rgba($carrot, 0.16);\n$rainboots16: rgba($rainboots, 0.16);\n$royalBlue16: rgba($royalBlue, 0.16);\n\n// Box colors (for color picker)\n$boxRed: $red;\n$boxPink: #F57A7A;\n$boxOrange: $orange;\n$boxYellow: $yellow;\n$boxGreen: #95C653;\n$boxDarkGreen: #00A474;\n$boxBlue: #33ACE1;\n$boxDarkBlue: #3361E1;\n$boxPurple: #6D6DB5;\n$boxPurple16: rgba($boxPurple, 0.16);\n$boxDarkPurple: #332A4B;\n\n:export {\n  // Theme Colors\n  primary: $primary;\n  secondary: $secondary;\n  yellow: $yellow;\n  red: $red;\n  teal: $teal;\n  orange: $orange;\n  lightGray: $lightGray;\n  whiteSmoke: $whiteSmoke;\n  manatee: $manatee;\n  obsidian: $obsidian;\n\n  // Status Colors\n  success: $success;\n  warning: $warning;\n  error: $error;\n\n  // Other Colors\n  white: $white;\n  black: $black;\n  gray: $gray;\n  darkGray: $darkGray;\n  mediumGray: $mediumGray;\n  lighterGray: $lighterGray;\n  lightSlateGray: $lightSlateGray;\n  carrot: $carrot;\n  lightSmoke: $lightSmoke;\n  graphBlue: $graphBlue;\n  lightOrchid: $lightOrchid;\n  rainboots: $rainboots;\n  royalBlue: $royalBlue;\n  sushi: $sushi;\n\n  // Component Colors\n  primaryButtonBackground: $primaryButtonBackground;\n  primaryButtonText: $primaryButtonText;\n  secondaryButtonBackground: $secondaryButtonBackground;\n  secondaryButtonText: $secondaryButtonText;\n  navigationText: $navigationText;\n  scheduleMusic: $scheduleMusic;\n  scheduleMessageBlock: $scheduleMessageBlock;\n  scheduleInterrupt: $scheduleInterrupt;\n  scheduleLoop: $scheduleLoop;\n  \n  // Variants: Theme Colors\n  primary16: $primary16;\n  primary40: $primary40;\n  primary50: $primary50;\n  primary60: $primary60;\n  secondary25: $secondary25;\n  secondary50: $secondary50;\n  secondary75: $secondary75;\n  yellow16: $yellow16;\n  yellow25: $yellow25;\n  yellow75: $yellow75;\n  orange16: $orange16;\n  orange32: $orange32;\n  orange50: $orange50;\n  orange75: $orange75;\n  manatee16: $manatee16;\n  manatee50: $manatee50;\n\n  // Variants: Status Colors\n  success10: $success10;\n  success16: $success16;\n  success75: $success75;\n  warning50: $warning50;\n  error10: $error10;\n  error16: $error16;\n  error20: $error20;\n  error50: $error50;\n  error75: $error75;\n  error85: $error85;\n\n  // Variants: Other Colors\n  gray50: $gray50;\n  gray200: $gray200;\n  gray300: $gray300;\n  gray400: $gray400;\n  gray500: $gray500;\n  gray700: $gray700;\n  gray900: $gray900;\n  carrot16: $carrot16;\n  rainboots16: $rainboots16;\n  royalBlue16: $royalBlue16;\n  boxPurple16: $boxPurple16;\n\n  // Box colors (for color picker)\n  boxRed: $boxRed;\n  boxPink: $boxPink;\n  boxOrange: $boxOrange;\n  boxYellow: $boxYellow;\n  boxGreen: $boxGreen;\n  boxDarkGreen: $boxDarkGreen;\n  boxBlue: $boxBlue;\n  boxDarkBlue: $boxDarkBlue;\n  boxPurple: $boxPurple;\n  boxDarkPurple: $boxDarkPurple;\n}\n","@use '../../sass/color.scss' as color;\n\n.SidePanel {\n  position: fixed;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  z-index: 1301;\n  pointer-events: none;\n  transition: 0.8s ease backdrop-filter, 0.8s ease background-color;\n\n  &.show {\n\n    &.backdrop {\n      // Do not allow clicks outside the panel\n      pointer-events: auto;\n      background-color: color.$secondary50;\n      backdrop-filter: blur(2px);\n    }\n  }\n\n  > .backdrop-container {\n    display: flex;\n    height: 100%;\n\n    .backdrop-left {\n      flex-grow: 1;\n    }\n  }\n\n  .panel-root {\n    position: absolute;\n    top: 0;\n    right: 0;\n    height: 100%;\n    pointer-events: none;\n    overflow: hidden !important;\n  }\n\n  .panel-container {\n    display: inline-flex;\n    position: relative;\n    height: 100%;\n    transition: 0.8s ease right, 0.8s ease width;\n\n    > .panel {\n      display: flex;\n      flex-direction: column;\n      position: relative;\n      height: 100%;\n      background: color.$white;\n      box-shadow: 0 0 16px 0 rgba(0, 0, 0, 0.32);\n      box-sizing: border-box;\n      border-left: 1px solid color.$whiteSmoke;\n      pointer-events: auto;\n      overflow: hidden;\n\n      &.panel-secondary,\n      &.panel-tertiary,\n      &.panel-fourth {\n        box-shadow: none;\n      }\n\n      &.transition {\n        transition: none;\n      }\n\n      > .header {\n        display: flex;\n        flex-direction: column;\n        justify-content: center;\n        height: 72px;\n        padding: 0 24px;\n        padding-right: 0;\n        box-sizing: border-box;\n        border-bottom: 1px solid color.$whiteSmoke;\n\n        .toolbar {\n          display: flex;\n          align-items: center;\n\n          .title {\n            flex-grow: 1;\n            font-size: 18px;\n            line-height: 20px;\n            font-weight: 900;\n            white-space: nowrap;\n            overflow: hidden;\n            text-overflow: ellipsis;\n          }\n\n          // Overwrite the icon component style to pad toolbar icons\n          .VibeIcon {\n            padding: 24px 4px;\n\n            &:first-child {\n              padding-left: 24px;\n            }\n\n            &:last-child {\n              padding-right: 24px;\n            }\n\n            // Do not allow padding for the left icon\n            &.left-icon {\n              padding: 0;\n              margin-right: 4px;\n            }\n          }\n        }\n      }\n\n      > .content {\n        position: relative;\n        flex-grow: 1;\n        overflow: hidden;\n      }\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export var primary = `#333F48`;
export var secondary = `#222732`;
export var yellow = `#FECF0C`;
export var red = `#E02D4F`;
export var teal = `#23CCC3`;
export var orange = `#F66733`;
export var lightGray = `#F6F6F6`;
export var whiteSmoke = `#E1E1E9`;
export var manatee = `#959AAD`;
export var obsidian = `#383838`;
export var success = `#00A474`;
export var warning = `#FFC107`;
export var error = `#CF0838`;
export var white = `#FFFFFF`;
export var black = `#000000`;
export var gray = `#757575`;
export var darkGray = `#A4A7B7`;
export var mediumGray = `#E0E0E0`;
export var lighterGray = `#E3E7F4`;
export var lightSlateGray = `#8A8FA3`;
export var carrot = `#FF892E`;
export var lightSmoke = `#F5F4F5`;
export var graphBlue = `#1570EF`;
export var lightOrchid = `#7F56D9`;
export var rainboots = `#3361E1`;
export var royalBlue = `#4085DE`;
export var sushi = `#95C653`;
export var primaryButtonBackground = `#FECF0C`;
export var primaryButtonText = `#333F48`;
export var secondaryButtonBackground = `#333F48`;
export var secondaryButtonText = `#FFFFFF`;
export var navigationText = `#95A3AD`;
export var scheduleMusic = `#FCC7B3`;
export var scheduleMessageBlock = `#23CCC3`;
export var scheduleInterrupt = `#1997A3`;
export var scheduleLoop = `#333F48`;
export var primary16 = `rgba(51, 63, 72, 0.16)`;
export var primary40 = `rgba(51, 63, 72, 0.4)`;
export var primary50 = `rgba(51, 63, 72, 0.5)`;
export var primary60 = `rgba(51, 63, 72, 0.6)`;
export var secondary25 = `rgba(34, 39, 50, 0.25)`;
export var secondary50 = `rgba(34, 39, 50, 0.5)`;
export var secondary75 = `rgba(34, 39, 50, 0.75)`;
export var yellow16 = `rgba(254, 207, 12, 0.16)`;
export var yellow25 = `rgba(254, 207, 12, 0.25)`;
export var yellow75 = `rgba(254, 207, 12, 0.75)`;
export var orange16 = `rgba(246, 103, 51, 0.16)`;
export var orange32 = `rgba(246, 103, 51, 0.32)`;
export var orange50 = `rgba(246, 103, 51, 0.5)`;
export var orange75 = `rgba(246, 103, 51, 0.75)`;
export var manatee16 = `rgba(149, 154, 173, 0.16)`;
export var manatee50 = `rgba(149, 154, 173, 0.5)`;
export var success10 = `rgba(0, 164, 116, 0.08)`;
export var success16 = `rgba(0, 164, 116, 0.16)`;
export var success75 = `rgba(0, 164, 116, 0.75)`;
export var warning50 = `rgba(255, 193, 7, 0.5)`;
export var error10 = `rgba(207, 8, 56, 0.1)`;
export var error16 = `rgba(207, 8, 56, 0.16)`;
export var error20 = `rgba(207, 8, 56, 0.2)`;
export var error50 = `rgba(207, 8, 56, 0.5)`;
export var error75 = `rgba(207, 8, 56, 0.75)`;
export var error85 = `rgba(207, 8, 56, 0.85)`;
export var gray50 = `#F9FAFB`;
export var gray200 = `#EAECF0`;
export var gray300 = `#D0D5DD`;
export var gray400 = `#98A2B3`;
export var gray500 = `#667085`;
export var gray700 = `#344054`;
export var gray900 = `#101828`;
export var carrot16 = `rgba(255, 137, 46, 0.16)`;
export var rainboots16 = `rgba(51, 97, 225, 0.16)`;
export var royalBlue16 = `rgba(64, 133, 222, 0.16)`;
export var boxPurple16 = `rgba(109, 109, 181, 0.16)`;
export var boxRed = `#E02D4F`;
export var boxPink = `#F57A7A`;
export var boxOrange = `#F66733`;
export var boxYellow = `#FECF0C`;
export var boxGreen = `#95C653`;
export var boxDarkGreen = `#00A474`;
export var boxBlue = `#33ACE1`;
export var boxDarkBlue = `#3361E1`;
export var boxPurple = `#6D6DB5`;
export var boxDarkPurple = `#332A4B`;
export default ___CSS_LOADER_EXPORT___;
